<template>
    <footer id="footer" class="block block-bg-grey-dark block-bg-img bg-footer-map" data-stellar-background-ratio="0.4">
      <div class="container">
        <div class="row" id="contact">
          <div class="col-md-3">
            <address>
              <strong>Iowa Spring Manufacturing</strong>
              <br>
              <i class="fa fa-map-pin fa-fw text-primary"></i> PO Box 130
              <div>2112 Greene Street</div>
              <div>Adel, Iowa 50003</div>
              <a href="tel:1-800-622-2203" class="link-grey">
                <i class="fa fa-phone fa-fw text-primary"></i> 1-800-622-2203</a>
              <br>
              <a href="mailto:support@iowaspring.com" class="link-grey">
                <i class="fa fa-envelope-o fa-fw text-primary"></i> support@iowaspring.com</a>
              <br>
            </address>
          </div>

          <div class="col-md-6">
            <contact-us></contact-us>
          </div>
        </div>

        <div class="row subfooter">
          <div class="col-md-7">
            <p>Copyright © Iowa Spring Manufacturing</p>
            <p>Site design by
              <span class="text-primary">Ecliptic North</span>
            </p>

          </div>
          <div class="col-md-5 hidden">
            <ul class="list-inline pull-right">
              <li>
                <a href="#">Terms</a>
              </li>
              <li>
                <a href="#">Privacy</a>
              </li>
              <li>
                <a href="#">Contact Us</a>
              </li>
            </ul>
          </div>
        </div>

        <a href="#top" class="scrolltop">Top</a>

      </div>
    </footer>
</template>

<script>
import ContactUs from "@/components/ContactUs";

export default {
  name: "TheFooter",
  components: { ContactUs }
};
</script>

<style scoped>
.bg-footer-map {
  background-image: url(../../assets/img/bg_footer-map.png);
}
</style>




// WEBPACK FOOTER //
// src/components/layout/TheFooter.vue